<template>
  <div class="content">
    <Header :title="'登录'" />
    <div class="content-up">
      <div class="logo-wrap">
        <div class="logo">
          <img
            alt
            src="@/assets/images/logo.png"
          >
        </div>
      </div>
      <div class="form-wrap">
        <div class="my-row">
          <nut-textinput
            v-model="phone"
            :clear-btn="true"
            :disabled="false"
            :has-border="false"
            autocomplete="off"
            placeholder="手机号码"
            type="number"
          />
        </div>
        <div class="my-row">
          <nut-textinput
            v-model="password"
            :clear-btn="false"
            :has-border="false"
            :type="inputType"
            autocomplete="off"
            maxlength="20"
            placeholder="密码"
            @focus="inputFocus()"
          />
          <div
            v-show="toggleShow"
            @click="toggleEye()"
          >
            <i
              v-show="eyeShow"
              class="iconfont eyes-open"
            >&#xe745;</i>
            <i
              v-show="!eyeShow"
              class="iconfont eyes-close"
            >&#xe6a3;</i>
          </div>
        </div>
        <div class="my-row">
          <nut-checkbox
            v-model="checkbox"
            class="checkbox"
            @change="checkboxChange"
          >记住密码
          </nut-checkbox>
          <router-link to="/Account/FindPwd">
            <span class="forgrt-pwd">忘记密码？</span>
          </router-link>
        </div>
        <div class="my-row">
          <nut-button
            block
            @click="handleLogin()"
          >登录
          </nut-button>
        </div>
        <div class="my-row">
          <p class="resign">
            <span @click="goto('reg')">注 册</span>
          </p>
        </div>
      </div>
      <div
        v-show="$isWeiXin()"
        class="content-down"
      >
        <div class="bottom-wrap">
          <div class="login-type-explain">
            <div class="line" />
            <span>其它方式登录</span>
            <div class="line" />
          </div>
          <div class="login-weixin">
            <div
              class="weixin"
              @click="wxlogin"
            >
              <i class="iconfont weixin">&#xe6ea;</i>
              <nut-button
                block
                shape="circle"
              >微信账号登录
              </nut-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getWeChatCodeAuthorizeUrl, login, weChatLogin } from '@/api/Account/index'
import { baseInfo } from '@/api/Personal'
import { Dialog, Toast } from 'vant'

import Storage from '@/utils/storage'
import Header from '@/components/Header/Index'

export default {
  name: 'Login',
  components: {
    Header
  },
  data() {
    return {
      phone: '',
      password: '',
      checkbox: false,
      isChecked: null,
      jwtToken: '',
      eyeShow: false,
      toggleShow: false,
      isWeixinLogin: true
    }
  },
  computed: {
    inputType() {
      return this.eyeShow ? 'text' : 'password'
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/Account/Reg' && to.query.openId) {
      next((vm) => {
        vm.$router.go(-1)
      })
    } else {
      next()
    }
  },
  watch: {
    $route(to, from) {
      const self = this
      const { code, nextUrl, replace } = this.$route.query
      window.console.log('watch', code, replace, nextUrl)
      if (code && replace === 'yes') {
        Toast.loading({
          duration: 3000,
          forbidClick: true,
          message: '正在登录...'
        })
        weChatLogin(code).then((res) => {
          Toast.clear()
          if (res && res.success) {
            if (res.data.result_code === 'SUCCESS') {
              localStorage.jwtToken = res.data.token
              self.goto('login')
            } else {
              // 没有绑定帐号
              Dialog
                .confirm({
                  message: '当前微信号尚未绑定万家香火帐号',
                  width: '80vw',
                  confirmButtonColor: '#d08d04',
                  confirmButtonText: '立即注册',
                  cancelButtonText: '登录绑定'
                })
                .then(() => {
                  self.goto({
                    path: '/Account/Reg',
                    query: { openId: res.data.openId }
                  })
                })
                .catch(() => {
                  this.$router.go(-1)
                })
            }
          } else {
            Toast.fail(res.msg)
          }
        })
      }
    }
  },
  mounted() {
    this.hasUser()

    const { code, nextUrl, replace } = this.$route.query

    if (code) {
      if (replace !== 'yes') {
        window.console.log('地址替换')
        this.$router.replace({
          path: '/Account/Login',
          query: { code: code, replace: 'yes' }
        })
      }
    } else {
      if (!this.$isEmpty(nextUrl)) {
        sessionStorage.nextUrl = nextUrl
      }
    }
  },
  methods: {
    hasUser() {
      if (Storage.localGet('phone') !== '') {
        this.phone = Storage.localGet('phone')
      }
      if (Storage.localGet('password') !== '') {
        this.password = Storage.localGet('password')
      }
    },
    handleLogin() {
      const _this = this
      if (this.phone === '') {
        Toast.fail('手机号不能为空')
        return
      }
      if (_this.$isPhone(_this.phone) === false) {
        Toast.fail('请输入正确手机号')
        return
      }
      if (this.password === '') {
        Toast.fail('密码不能空')
        return
      }
      if (this.password && this.password.length < 6) {
        Toast.fail('请输入6位以上密码')
        return
      }
      Storage.localSet('jwtToken', '')
      // 接口--登陆
      login(this.phone, this.password).then(res => {
        if (res && res.success) {
          localStorage.jwtToken = res.data
          this.initUserInfo(res.data)
          Toast.success('登录成功')
          this.goto('login')
        } else {
          Toast.fail(res.msg)
        }
      })
      Storage.localSet('phone', _this.phone)
      // 记住密码
      if (this.isChecked === true) {
        Storage.localSet('password', _this.password)
      } else {
        Storage.localRemove('password')
      }
    },
    checkboxChange(checked) {
      this.isChecked = checked
    },
    initUserInfo(token) {
      baseInfo(token).then(res => {
        if (res && res.success) {
          if (res.data) {
            const userInfo = res.data
            Storage.localSet('userInfo', userInfo)
          }
        }
      })
    },
    wxlogin() {
      if (this.$isWeiXin() === false || this.isWeixinLogin === false) {
        return
      }
      this.isWeixinLogin = false
      // 接口中返回
      getWeChatCodeAuthorizeUrl('/Account/Login').then(res => {
        this.isWeixinLogin = true
        if (res && res.success) {
          window.location.replace(res.data)
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    toggleEye() {
      this.eyeShow = !this.eyeShow
    },
    // 监听input的focus
    inputFocus() {
      this.toggleShow = true
    },
    goto(data) {
      const nextUrl = sessionStorage.nextUrl
      // console.log(data, nextUrl)
      if (data === 'login') {
        data = { path: nextUrl || '/Personal', query: {} }
        sessionStorage.removeItem('nextUrl')
        this.$router.replace(data)
        return
      } else if (data === 'reg') {
        data = {
          path: '/Account/Reg',
          query: { nextUrl: nextUrl }
        }
      } else if (data === 'newreg') {
        data = {
          path: '/Account/Reg',
          query: { nextUrl: nextUrl }
        }
      } else if (typeof data === 'string') {
        data = { path: data }
      }
      data.query.nextUrl = nextUrl
      this.$router.push(data)
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep .nut-textinput input {
  height: 42px;
  line-height: 42px;
}

::v-deep .nut-button {
  background: #dc9a10;
  border-radius: 5px;
  -webkit-appearance: none;
  appearance: none;
  height: 42px;
  line-height: 42px;
}

::v-deep .nut-checkbox input:checked {
  background-color: #dc9a10;
  background-repeat: no-repeat;
  background-position: center;
  border-color: #dc9a10;
  background-size: 60%;
  box-shadow: 0 4px 6px 0 rgba(220, 154, 15, 0.15);
}

::v-deep .nut-button.circle {
  border-radius: 50px;
  background: transparent;
  color: #808080;
  border: 1px solid #cccccc;
  height: 35px;
  line-height: 35px;
  font-size: 13px;
}

.content {
  width: 100vw;
  min-height: 100vh;
  height: auto;
  overflow: hidden;
  background-image: url('~@/assets/images/login-bg.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;

  .content-up {
    flex: 1;
  }

  .logo-wrap {
    width: 100%;
    height: 125px;
    position: relative;
    box-sizing: border-box;
    padding: 40px 0;

    .logo {
      width: 100%;
      height: 79px;
      display: flex;
      justify-content: center;

      img {
        width: 104px;
      }
    }
  }

  .form-wrap {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 40px 23px 0 23px;
    box-sizing: border-box;
    margin-bottom: 20px;

    .my-row {
      margin-bottom: 18px;
      color: #80765d;
      position: relative;

      .forgrt-pwd {
        float: right;
        font-size: 13px;
        color: #80765d;
      }

      .resign {
        font-size: 14px;
        text-align: center;
        margin: 0;
        padding: 0;

        span {
          text-decoration: underline;
          color: #875320;
        }
      }

      .eyes-open {
        position: absolute;
        right: 5px;
        top: 9px;
        font-size: 24px;
        color: #999999;
      }

      .eyes-close {
        position: absolute;
        right: 10px;
        top: 15px;
        font-size: 16px;
        color: #999999;
      }
    }
  }

  .bottom-wrap {
    width: 100%;
    height: 100px;

    .login-type-explain {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 0 77px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .line {
        width: 30px;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      span {
        width: 80px;
        text-align: center;
        font-size: 10px;
        color: #999999;
      }

      img {
        width: 100%;
        height: 10px;
      }
    }

    .login-weixin {
      margin-top: 10px;
      width: 100%;
      box-sizing: border-box;
      padding: 15px 63px;
      position: relative;

      .weixin {
        width: 100%;
        position: relative;

        .iconfont.weixin {
          font-size: 20px;
          color: #4cbf00;

          position: absolute;
          left: 20px;
          top: 6px;
        }
      }
    }
  }
}
</style>
